import { Translation } from 'react-i18next';
import { TFunction } from 'i18next';

import { useTheme } from 'styled-components';
import _ from 'lodash';
import { StyledMessageWrapper } from 'components/player/detail/Account.styled';
import { IconSvg } from 'shared/icon';

interface FormItemErrorMessageProps {
  errorMassage: string | ((translate: TFunction) => string);
}

const FormItemErrorMessage = ({ errorMassage }: FormItemErrorMessageProps) => {
  const { colors } = useTheme();

  return (
    <StyledMessageWrapper>
      <IconSvg icon="CrossThinIcon" width="1.43rem" height="1.43rem" color={colors.danger} />
      <span>{_.isString(errorMassage) ? errorMassage : <Translation>{(translate) => errorMassage(translate)}</Translation>}</span>
    </StyledMessageWrapper>
  );
};

export default FormItemErrorMessage;
